import { useEffect, useState } from "react";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";

interface ProcedureFunctions {
    _exportMap: Function;
    _procedure: any;
    _pocessData?: any;
    _pushInfo?: Function;
    _pushProps?: Function;
}

interface Props {
    configProcedure: ProcedureFunctions;
}

interface Resp {
    Obs: string;
    Approve: string;
    Code: string;
}

export const SOLCENCOST001 = ({ configProcedure }: Props) => {

    const [response, setResponse] = useState<Resp>({
        Approve: "",
        Obs: "",
        Code: ""
    })

    const onExportMap = () => {
        configProcedure?._pushProps(response);

        configProcedure?._pushInfo(response.Obs)

        configProcedure?._exportMap(response)
    }

    useEffect(() => {
        if (response.Approve !== "") {
            onExportMap();
        }
    }, [response]);

    const updateForm = (app: boolean) => {
        setResponse(prev => ({ ...prev, Approve: `${app}` }));
    }


    return (
        <>
            <div className="row d-flex justify-content-between">
                <div className="col-md-6">
                    <label >Código de Centro de Costo Asignado</label>
                    <input type="text" className="form-control" value={response.Code} onChange={(e) => { setResponse({ ...response, Code: e.target.value }) }} />
                </div>
                <div className="col-md-12 mb-2">
                    <label>Observaciones</label>
                    <textarea className="form-control" value={response.Obs} onChange={(e) => { setResponse({ ...response, "Obs": e.target.value }) }} />
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-checkbox-circle-line" eventClick={() => {
                        if (response.Code !== "") {
                            updateForm(true)
                        } else {
                            toast.error("Tiene que Asignar un Código")
                        }
                    }} >Aprobar</BasicButton>
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-close-circle-line" eventClick={() => { updateForm(false) }} >Rechazar</BasicButton>
                </div>
            </div>

        </>
    );
};